<div class="codex-quarter-main-container">
    <div class="quarter-title-and-list-container">
      <div class="d-flex align-items-center gap-3">
        <span class="quarter-title">{{ "wo_codex_title"| translate }} {{currentQuarter?.name}} |</span>
        <a class="team-name-link" (click)="goBackToTeam()">{{teamNameToDisplay}}</a>
      </div>
        <p-dropdown
            [options]="quarterList"
            optionLabel="quarter"
            [(ngModel)]="currentQuarter"
            (onChange)="changeQuarter($event.value.index)"
            dropdownIcon="bi bi-caret-down-fill"
            styleClass="wo-dropdown"
            panelStyleClass="wo-dropdown-panel"
            dataKey="uuid">
        </p-dropdown>
    </div>
    <div class="quarter-score-and-indicator-container">
        <div class="overall-score-container">
            <h1 class="topic-container-title">{{'score' | translate}}</h1>
            <app-gauge-display
                [value]="currentQuarter.score.value"
                [width]="215"
                [height]="190"
                [isOnTeamCodex]="true"
                [trend]="currentQuarter.isPreviousReportEligible ? currentQuarter.score.trend : null"
                [colorStart]="currentQuarter.score.color"
                [colorEnd]="currentQuarter.score.color"
                [backgroundColor]="'rgba(240, 243, 250, 1)'">
            </app-gauge-display>
            <div class="change-index-container">
                <div class="change-index-value">
                    <img *ngIf="currentQuarter.score.diff.trend && currentQuarter.isPreviousReportEligible" [class]="'arrow-' + currentQuarter.score.diff.trend" [src]="'../../../assets/svg/indicator-arrow-'+currentQuarter.score.diff.trend+'.svg'">
                    <i class="trend-dash bi bi-dash-lg" *ngIf="!currentQuarter.score.diff.trend || !currentQuarter.isPreviousReportEligible"></i>
                    <span *ngIf="currentQuarter.isPreviousReportEligible" class="change-index-value-diff">{{(currentQuarter.score.diff.value > 0) ? ('+'+currentQuarter.score.diff.value+'%'):(currentQuarter.score.diff.value+'%')}}</span>
                    <span *ngIf="!currentQuarter.isPreviousReportEligible" class="change-index-value-diff">{{0+'%'}}</span>
                </div>
                <span class="change-index-value-text">{{'wo_codex_progress_change'|translate}}</span>
            </div>
        </div>
        <div class="quarter-indicators-container">
            <div class="topic-indicator-container" *ngFor="let indicator of currentQuarter.details">
                <div [ngStyle]="{'background-image':indicator.gradientColor}" class="topic-indicator-icon-container">
                    <img [src]="'../../../assets/icons/codex/'+indicator.category.slug+'.svg'">
                </div>
                <span class="topic-indicator-title">{{indicator.category.title}}</span>
                <div class="topic-indicator-value-container">
                    <span class="topic-indicator-value">{{indicator.score}}</span>
                    <span class="topic-indicator-value-percentage">%</span>
                    <img class="topic-indicator-trend" *ngIf="indicator.trend && currentQuarter.isPreviousReportEligible"
                        [class]="'arrow-' + indicator.trend"
                        [src]="'../../../assets/svg/indicator-arrow-'+indicator.trend+'.svg'">
                </div>
            </div>
        </div>
    </div>
    <div class="quarter-table-container">
        <p-table [value]="currentQuarter.questions" responsiveLayout="scroll">
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width:4%">
                    <col style="width:32%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <!-- <div class="quarter-table-cell quarter-header-cell">CODEX</div> -->
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">STATEMENT</div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option1' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option2' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option3' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'middle' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option5' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option6' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option7' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div #origin6="cdkOverlayOrigin" cdkOverlayOrigin class="quarter-table-cell quarter-header-cell d-flex gap-2 align-items-center justify-content-center">
                            SCORE
                            <i class="bi bi-filter sorting-icon icon-flex-alignment"
                                [ngClass]="{'show-badge' : hasActiveSort('average_score')}"
                                (click)="openSortMenu('average_score')"
                                pBadge badgeDot severity="info">
                            </i>
                            <ng-template
                                cdkConnectedOverlay
                                [cdkConnectedOverlayOrigin]="origin6"
                                [cdkConnectedOverlayOpen]="activeMenuCategory === 'average_score'"
                                (backdropClick)="activeMenuCategory = null"
                                [cdkConnectedOverlayHasBackdrop]="true"
                                cdkConnectedOverlayBackdropClass="transparent-backdrop">
                                <div class="sorting-main-container">
                                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                                    <input
                                        class="sorting-checkbox"
                                        type="checkbox"
                                        [checked]="isChecked('average_score', 'ASC')"
                                        (change)="toggleSort('average_score', 'ASC')">
                                    <span style="font-size: 1.4rem;">Ascending</span>
                                    </label>
                                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                                    <input
                                        class="sorting-checkbox"
                                        type="checkbox"
                                        [checked]="isChecked('average_score', 'DESC')"
                                        (change)="toggleSort('average_score', 'DESC')">
                                    <span style="font-size: 1.4rem;">Descending</span>
                                    </label>
                                </div>
                            </ng-template>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-indicator>
                <tr>
                    <td>
                        <div class="d-flex align-items-center transparent-background"
                            pTooltip="{{indicator.category.title}}" tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                            <div class="quarter-table-cell-icon" [ngStyle]="{'background-image':indicator.gradientColor}">
                                <img [src]="'../../../assets/icons/codex/'+indicator.category.slug+'.svg'">
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="quarter-table-cell">
                            {{indicator.question}}
                        </div>
                    </td>
                    <td *ngFor="let questionCategory of indicator.details">
                        <div [ngClass]="{'bold-box' : questionCategory.isHighest}" class="d-flex align-items-center justify-content-center quarter-table-cell">
                            {{questionCategory.percentage+'%'}}
                        </div>
                    </td>
                    <td>
                        <div [ngStyle]="{'background-color': indicator.fadeColor}" class="d-flex align-items-center justify-content-center fw-bold quarter-table-cell">
                            {{indicator.score+'%'}}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="codex-quarter-history-container">
    <span class="quarter-title">Quarter History</span>
    <div class="quarter-history-table-container">
        <p-table [value]="quarterList" responsiveLayout="scroll">
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width:7%">
                    <col style="width:12%">
                    <col style="width:12%">
                    <col style="width:12%">
                    <col style="width:12%">
                    <col style="width:12%">
                    <col style="width:10%">
                    <col style="width:12%">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="d-flex align-items-center justify-content-center quarter-table-cell quarter-history-header-cell">QUARTER</div>
                    </th>
                    <th *ngFor="let indicator of quarterList[0].details">
                        <div class="d-flex align-items-center justify-content-center quarter-table-cell quarter-history-header-cell"
                            pTooltip="{{indicator.category.title}}" tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                            <img [src]="'../../../assets/icons/codex/'+indicator.category.slug+'_black.svg'">
                        </div>
                    </th>
                    <th>
                        <div class="d-flex align-items-center justify-content-center quarter-table-cell quarter-history-header-cell">SCORE</div>
                    </th>
                    <th>
                        <div class="d-flex align-items-center justify-content-center quarter-table-cell quarter-history-header-cell">DEVELOPMENT</div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr>
                    <td>
                        <div class="d-flex align-items-center">
                            <div class="quarter-history-table-cell justify-content-center w-100">
                                {{report.quarter}}
                            </div>
                        </div>
                    </td>
                    <td *ngFor="let indicator of report.details">
                        <div class="d-flex align-items-center">
                            <div [ngStyle]="{'background-color': indicator.fadeColor}" class="quarter-history-table-cell justify-content-center gap-1 w-100">
                                {{indicator.score+'%'}}
                                <img *ngIf="indicator.trend && report.isPreviousReportEligible"
                                    [class]="'arrow-' + indicator.trend"
                                    [src]="'../../../assets/svg/indicator-arrow-'+indicator.trend+'.svg'">
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center">
                            <div [ngStyle]="{'color': report.score.hexColor}" class="quarter-history-table-cell justify-content-center fw-bold fs-3 w-100">
                                {{report.score.value+'%'}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center">
                            <div class="quarter-history-table-cell justify-content-center w-100">
                                {{(report.progress.value !== 0 && report.isPreviousReportEligible) ? report.progress.value+'%' : '-'}}
                                <img *ngIf="report.progress.trend && report.isPreviousReportEligible"
                                    [class]="'arrow-' + report.progress.trend"
                                    [src]="'../../../assets/svg/indicator-arrow-'+report.progress.trend+'.svg'">
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
